import DictionaryGridPresentation from 'components/DictionaryGrid/DictionaryGridPresentation'

export default {
  Presentation: DictionaryGridPresentation,
}
